import { ErrorComponent } from "../../components";

export default function UnAuthorizedPage() {
  return <ErrorComponent.UnAuthorizedPage />;
}
